import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// rem h5 适配
import 'amfe-flexible'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
